// javascript
import menu from './menu/menu.json';

import footer from './footer/footer.json';

import homeAbout from './home/home-about.json';
import swiperProjects from './home/home-projects.json';
import homeContact from './home/home-contact.json';

import about from './about/content.json';
import game from './about/game.json';

import projects from './projets/projets.json';
import singleContact from './projets/single-contact.json';

import contact from './contact/content.json';

import pageNotFound from './page-not-found/content.json';

import cookies from './cookies/cookies.json';


const sources = [menu, footer, homeAbout, swiperProjects, homeContact, about, game, projects, singleContact, contact, pageNotFound, cookies];

// Fusionne les sources en un seul objet translations par langue
const translations = sources.reduce((acc, src) => {
    Object.keys(src).forEach((lang) => {
        acc[lang] = acc[lang] || {};
        acc[lang] = { ...acc[lang], ...src[lang] };
    });
    return acc;
}, {});

export const getLang = () => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem('lang') : null;
    if (stored && translations[stored]) return stored;
    const nav = typeof navigator !== 'undefined' ? (navigator.language || navigator.userLanguage || 'fr').slice(0, 2) : 'fr';
    return translations[nav] ? nav : Object.keys(translations)[0] || 'fr';
};

export const l = (key, lang = getLang(), opts = {}) => {
    // compat: if opts passed as boolean, treat as { allowObject: !!opts }
    const allowObject = typeof opts === 'boolean' ? opts : !!opts.allowObject;
    const result = (translations[lang] && translations[lang][key]) || undefined;
    if (result === undefined) return key;

    // If object/array and not allowed, warn and return the key (safe fallback)
    if (!allowObject && typeof result === 'object') {
        // eslint-disable-next-line no-console
        console.warn(`[l] key "${key}" for lang "${lang}" returns non-primitive. Returning key instead to avoid rendering objects.`, result);
        return typeof key === 'string' ? key : '';
    }

    return result;
};

export default translations;
